<p>
  Enter your anticipated growth. Note that values entered here will be used for all years until retirement or termination, and will increase the average pensionable earnings accordingly.
</p>
<p>We have set a default value of 0%.</p>
